import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChurchService } from 'src/app/church/church.service';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { MembersService } from 'src/app/members/members.service';
import { Church } from 'src/app/shared/interfaces/church.interface';
import { User } from 'src/app/shared/interfaces/user.interface';
import { AreaService } from '../area.service';

@Component({
  selector: 'app-area-form',
  templateUrl: './area-form.component.html',
  styleUrls: ['./area-form.component.css'],
})
export class AreaFormComponent implements OnInit {
  form: FormGroup;
  id;
  churchs: Church[] = [];
  members: User[] = [];

  constructor(
    private activeRouter: ActivatedRoute,
    private arearService: AreaService,
    private churchService: ChurchService,
    private toastr: ToastrService,
    private router: Router,
    private memberService: MembersService,
    private loadService: LoaderService
  ) {
    this.activeRouter.params.subscribe((params: Params) => {
      if (params.id) {
        this.id = params.id;
        this.loadArea();
      }
      this.loadChurchs();
      this.getMembers();
    });
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      description: new FormControl('', [Validators.required, Validators.minLength(5)]),
      church_id: new FormControl('', [Validators.required]),
      leader_id: new FormControl(''),
    });
  }

  loadChurchs(): Promise<any> {
    return this.churchService
      .get()
      .then((res) => {
        this.churchs.push(res);
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
      });
  }

  loadArea() {
    this.loadService.showLoader();
    this.arearService
      .getById(this.id)
      .then((res) => {
        delete res.id;
        this.form.setValue({
          description: res.description,
          church_id: res.church_id,
          leader_id: res.leader_id,
        });
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
        this.loadService.closeLoader();
      });
  }

  save() {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    let area = this.form.value;
    this.arearService
      .update(this.id, area)
      .then((res) => {
        this.toastr.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('area');
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu');
      });
  }

  add(): Promise<any> {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    let area = this.form.value;
    return this.arearService
      .addArea(area)
      .then((res) => {
        this.toastr.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('area');
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu');
      });
  }

  getMembers(): Promise<any> {
    return this.memberService
      .get()
      .then((res) => {
        this.members = res;
      })
      .catch((err) => {
        this.toastr.error(err.messsage || 'Falha ao carregar membros!');
      });
  }
}
